module.exports = __webpack_public_path__ + "img/yurt-logo-default.e0599e60.jpg";